import React from "react";
import ClinicalSurvey from "../../../components/smart/ClinicalSurvey/ClinicalSurvey";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";
import styled from "styled-components";
import PrimaryButton from "../../../components/ui-library/Buttons/PrimaryButton/PrimaryButton";
import CustomModal from "../../../components/ui-library/CustomModal/CustomModal";
import { useState } from "react";
import ConfirmRequest from "../../../components/library/ConfirmRequest/ConfirmRequest";
import history from "../../../modules/history";
import { useTranslation } from "react-i18next";

const SurveyContainer = styled.div`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 50px;
`;

const Survey = (props) => {
  const { t } = useTranslation();
  const {
    match: {
      params: { surveyDefinitionId, participantId },
    },
    claims,
  } = props;

  const [modal, setModal] = useState(false);
  const [done, setDone] = useState(false);

  return (
    <>
      <SurveyContainer>
        {claims?.includes("survey.canAnswer") && (
          <ClinicalSurvey
            surveyId={surveyDefinitionId}
            onComplete={() => setDone(true)}
          />
        )}
        <Footer>
          <CustomModal
            title={t("appText.survey.confirmation.title")}
            show={modal && !done}
            onClose={() => setModal(!modal)}
          >
            <p>{t("appText.survey.confirmation.message")}</p>
            <ConfirmRequest
              onConfirm={() => history.push("/participant")}
              onClose={() => setModal(!modal)}
            />
          </CustomModal>
          <PrimaryButton
            size="sm"
            onClick={() =>
              done ? history.push("/participant") : setModal(!modal)
            }
          >
            {t("appText.survey.confirmation.return")}
          </PrimaryButton>
        </Footer>
      </SurveyContainer>
    </>
  );
};

export default connect(mapStateToPropsLogin, null)(Survey);
